<ng-container>
  <div #sortTableElement id="sortTableElement">
    <div class="sortTable">
      <div class="sortTable__wrapper sortTable__wrapper--header">
        <h5 class="sortTable__title">{{sortTableTitle}}</h5>

        <div class="sortTable__globalFilter">
          <mat-form-field>
            <mat-label class="sortTable__label">Global Filter</mat-label>
            <input matInput placeholder="Ex. Abc-123" (keyup)="sortTableGeneralFilter($event)" class="sortTable__input" id="globalFilter">
            <button matSuffix mat-flat-button aria-label="Reset Filter" (click)="sortTableResetAllFilters()" class="sortTable__btn sortTable__btn--resetFilter">Reset All Filters</button>
          </mat-form-field>
        </div>
      </div>

      <div class="mat-elevation-z8 sortTable__wrapper">
        <table mat-table matSort [dataSource]="dataSource" class="sortTable__table">
          <caption class="sortTable__description">Sort Table</caption>
          <ng-container *ngFor="let colName of displayedColumns" matColumnDef="{{colName}}">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="sortTable__th" scope="col"> {{sortTableAllHeaders[colName]}} </th>
            <td mat-cell *matCellDef="let row" class="sortTable__td">
              <ng-container *ngIf="sortTableAllHref[row[colName]]">
                <ng-container *ngFor="let taskDataModRef of taskDataModuleRef[row[colName]];">
                  <a class="sortTable__link" [href]="getHRefLink(taskDataModRef)">{{taskDataModRef}}</a>&nbsp;
                </ng-container>
              </ng-container>

              <ng-container *ngIf="!sortTableAllHref[row[colName]]">
                {{row[colName]}}
              </ng-container>
            </td>
          </ng-container>

          <ng-container *ngFor="let filterName of displayedColumnsFilter; let filterIndex = index" matColumnDef="{{filterName}}">
            <th mat-header-cell *matHeaderCellDef class="sortTable__th sortTable__th--filter" scope="col">
              <div class="sortTable__columnFilter">
                <mat-form-field>
                  <mat-label class="sortTable__label">Filter {{sortTableFilterObj[filterIndex].name}}</mat-label>
                  <input matInput name="sortTable_{{filterName}}" (keyup)="sortTableColumnFilter(sortTableFilterObj[filterIndex], $event)" placeholder="{{sortTableFilterObj[filterIndex].name}}" class="sortTable__input" id="sortTableColumnFilter_{{filterIndex}}">
                  <button matSuffix mat-icon-button aria-label="Reset Filter" (click)="sortTableResetFilter(sortTableFilterObj[filterIndex], filterIndex)" class="sortTable__icon">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </th>
          </ng-container>

          <ng-container *ngFor="let notFoundTitle of sortTableFilteredDataNotFound.rowDef" matColumnDef="{{notFoundTitle}}">
            <td mat-footer-cell *matFooterCellDef [attr.colspan]="sortTableFilteredDataNotFound.colspan" class="sortTable__td sortTable__td--footer">
              <span *ngIf="sortTableFilteredDataNotFound.notFound" class="sortTable__notFound">No data matching the filter</span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsFilter; sticky: true" class="sortTable__filters"></tr>
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="sortTable__header"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="sortTable__row"></tr>
          <tr mat-footer-row *matFooterRowDef="sortTableFilteredDataNotFound.rowDef" class="sortTable__footer"></tr>
        </table>

        <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]"></mat-paginator>
      </div>
    </div>
  </div>
</ng-container>
